<template>
  <b-container fluid>
      <b-row>
        <b-col lg="12" sm="12" class="text-center mb-4">
            <h5 class='complain-title'>{{ $t('globalTrans.payment') }}</h5>
        </b-col>
        <b-col lg="12" sm="12">
            <b-overlay :show="loading">
            <template>
                <b-row v-if="is_payment">
                    <b-col class="text-dark">
                        <b-button @click="is_payment = false" class="btn btn-sm btn-warning"><span><i class="ri-arrow-left-line"></i>Back</span></b-button>
                    </b-col>
                    <b-col class="mt-3" lg="12" sm="12">
                        <div class="text-center">
                            <b-form-radio-group
                            v-model="payment_type_id"
                            :options="paymentTypeList"
                            ></b-form-radio-group>
                        </div>
                        <keep-alive>
                            <component v-bind:is="comp" :type_id="search.type_id" :edit_payment="search.edit_payment" :payment="payment" @clicked="onClickChild"></component>
                        </keep-alive>
                    </b-col>
                </b-row>
                <b-row v-else>
                    <b-col>
                        <b-row>
                            <b-col lg="12" sm="12">
                                <span style="font-size: 20px;font-weight:bold" class="text-dark"><u>{{ $t('externalUser.receive_list') }}</u></span>
                                <b-table-simple striped bordered small>
                                    <b-tr>
                                        <b-th>{{ $t('globalTrans.sl_no') }}</b-th>
                                        <b-th>{{ $t('retailerManagement.product_name') }}</b-th>
                                        <b-th>{{ $t('retailerManagement.quantity') }}</b-th>
                                        <b-th>{{ $t('retailerManagement.received_quantity') }}</b-th>
                                        <b-th>{{ $t('retailerManagement.unit_price') }}</b-th>
                                        <b-th>{{ $t('retailerManagement.total_price') }}</b-th>
                                    </b-tr>
                                    <b-tr v-for="(item, index) in formData.delivery_rec_main.details" :key="index">
                                        <b-td>{{ $n(index + 1) }}</b-td>
                                        <b-td>{{ productNameById(item.product_id) }}</b-td>
                                        <b-td>{{ $n(item.quantity) }}</b-td>
                                        <b-td>{{ $n(item.receive_quantity) }}</b-td>
                                        <b-td>{{ $n(item.unit_price) }}</b-td>
                                        <b-td>{{ $n(item.total_price) }}</b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td colspan="5">
                                            <span style="margin-left:80%">{{ $t('globalTrans.net_amount') }} </span>
                                        </b-td>
                                        <b-td>
                                            {{ $n(formData.delivery_rec_main.total_amount) }}
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td colspan="5">
                                            <span style="margin-left:80%">{{ $t('globalTrans.vat') }} (-) </span>
                                        </b-td>
                                        <b-td>
                                            <b-form-input
                                                placeholder=""
                                                id="vat"
                                                @keyup="calculateGrandTotal(formData.delivery_rec_main)"
                                                v-model="formData.delivery_rec_main.vat"
                                                min="0"
                                            >
                                            </b-form-input>
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td colspan="5">
                                            <span style="margin-left:80%">{{ $t('globalTrans.tax') }} (-) </span>
                                        </b-td>
                                        <b-td>
                                            <b-form-input
                                                placeholder=""
                                                id="vat"
                                                min="0"
                                                @keyup="calculateGrandTotal(formData.delivery_rec_main)"
                                                v-model="formData.delivery_rec_main.tax"
                                            >
                                            </b-form-input>
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td colspan="5">
                                            <span style="margin-left:80%">{{ $t('globalTrans.amount') }} </span>
                                        </b-td>
                                        <b-td>
                                            <ValidationProvider name="Amount" vid='amount' :rules="`max_value:${formData.delivery_rec_main.total_amount}`">
                                                <b-form-group
                                                    slot-scope="{ valid, errors }"
                                                >
                                                    <b-form-input
                                                    id="amount"
                                                    v-model="formData.amount"
                                                    :disabled="parseInt(previousDueAmount) === 0"
                                                    @keyup="calculateDueAmount(formData.amount)"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    ></b-form-input>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td colspan="5">
                                            <span style="margin-left:80%">{{ $t('externalUser.grand_toal') }}</span>
                                        </b-td>
                                        <b-td>{{ formData.delivery_rec_main.vat || formData.delivery_rec_main.tax> 0 ?  $n(formData.delivery_rec_main.grand_total) : $n(formData.delivery_rec_main.total_amount) }}</b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td colspan="5">
                                            <span style="margin-left:80%">{{ $t('externalUser.total_due') }}</span>
                                        </b-td>
                                        <b-td>{{ $n(formData.delivery_rec_main.due_amount) }}</b-td>
                                    </b-tr>
                                </b-table-simple>
                            </b-col>
                            <div class="col-md-12">
                                <b-table-simple striped bordered small>
                                    <b-tr>
                                        <b-td>
                                            <span style="margin-left:80%">{{ $t('externalUser.grand_toal') }}</span>
                                        </b-td>
                                        <b-td>{{$n(formData.delivery_rec_main.total_amount) }}</b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td>
                                            <span style="margin-left:80%">{{ $t('externalUser.total_due') }}</span>
                                        </b-td>
                                        <b-td>{{ $n(formData.delivery_rec_main.due_amount) }}</b-td>
                                    </b-tr>
                                </b-table-simple>
                            </div>
                            <div class="col-md-12">
                                <div class="text-right">
                                    <b-button :disabled="formData.delivery_rec_main.due_amount < 0 || formData.amount < 0 || formData.amount == ''" @click="setPayment(formData.delivery_rec_main, 0)" class="btn btn-success btn-sm" style="width:90px">{{ $t('sales_distribution_admin.payment_edit') }}</b-button>
                                </div>
                            </div>
                        </b-row>
                    </b-col>
                </b-row>
                <div class="row mt-4">
                    <div class="col-md-12 text-right">
                        <b-button variant="danger"  class="mr-1" @click="$bvModal.hide('payment-edit')">{{ $t('globalTrans.close') }}</b-button>
                    </div>
                </div>
            </template>
            </b-overlay>
        </b-col>
      </b-row>
    </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { core } from '@/config/pluginInit'
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { PaymentShow } from '../../api/routes'
import PaymentOthers from './PaymentOthers'
import PaymentCash from './PaymentCash'
import PaymentCheck from './PaymentCheck'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  props: ['id'],
  components: {
    PaymentCheck,
    PaymentCash,
    PaymentOthers,
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
        search: {
            delivery_order_id: '',
            edit_payment: false,
            user_id: '',
            type_id: '',
            category_id: 0
        },
        previousPayAmount: 0,
        previousDueAmount: 0,
        formData: '',
        is_payment: false,
        comp: 'PaymentCash',
        loading: false,
        showPayment: false,
        payment_type_id: 3,
        payment: {
            is_partial: '',
            paymentList: ''
        }
    }
  },
  created () {
    if (this.id) {
      this.getagentData()
    }
  },
  computed: {
    ...mapGetters({
        productCommonObj: 'ProductionService/commonObj'
    }),
    paymentTypeList () {
        return this.productCommonObj.paymentTypeList.filter(item => item.value !== 1)
    },
    currentLocale () {
      return this.$i18n.locale
    }
  },
  watch: {
    payment_type_id: function (n, o) {
        if (n !== o) {
          if (n === 2) {
              this.comp = 'PaymentCheck'
          } else if (n === 4) {
            this.comp = 'PaymentOthers'
          } else {
              this.comp = 'PaymentCash'
          }
        }
    }
  },
  mounted () {
    core.index()
  },
  methods: {
    getagentData () {
        this.loading = true
        RestApi.getData(productionServiceBaseUrl, PaymentShow + `/${this.id}`).then(response => {
            if (response.success) {
                this.loading = false
                this.showPayment = true
                const tmpData = response.data
                if (parseInt(tmpData.is_partial)) {
                    let newData = ''
                    let reciveMain = ''
                    if (parseInt(tmpData.user_type) === 3) {
                         reciveMain = tmpData.sc_delivery_rec_main
                         newData = tmpData.sc_delivery_rec_main.details
                    } else {
                         reciveMain = tmpData.delivery_rec_main
                         newData = tmpData.delivery_rec_main.details
                    }
                    const dd = Object.assign(reciveMain, { details: newData })
                    this.formData = Object.assign(tmpData, { delivery_rec_main: dd })
                } else {
                    if (tmpData.user_type < 3) {
                        this.formData = tmpData
                    } else {
                        this.formData = tmpData
                        this.formData.delivery_rec_main = tmpData.sc_delivery_rec_main
                    }
                }
                this.previousDueAmount = this.formData.delivery_rec_main.due_amount
                this.previousPayAmount = this.formData.amount
                this.payment_type_id = this.formData.payment_type_id
                this.search.type_id = this.formData.user_type
            }
            this.showPayment = false
        })
    },
    onClickChild () {
      this.$bvModal.hide('payment-edit')
    },
    calculateGrandTotal (item) {
        const result = item.details.reduce((total, item) => total + parseFloat(item.total_price), 0)
        const vat = isNaN(item.vat) || item.vat === '' ? 0 : parseFloat(item.vat)
        const tax = isNaN(item.tax) || item.tax === '' ? 0 : parseFloat(item.tax)
        const total = (parseFloat(result) - (vat + tax))
        item.grand_total = isNaN(total) ? item.total_price : total
    },
    calculateDueAmount (amount) {
        if (this.previousPayAmount > amount) {
            const changeAmount = parseFloat(this.previousPayAmount - amount)
            this.formData.delivery_rec_main.due_amount = parseFloat(this.previousDueAmount) + parseFloat(changeAmount)
        } else {
            const changeAmount = parseFloat(amount - this.previousPayAmount)
            this.formData.delivery_rec_main.due_amount = parseFloat(this.previousDueAmount) - parseFloat(changeAmount)
        }
    },
    productNameById (id) {
        const product = this.productCommonObj.productList.find(product => product.value === id)
        if (this.$i18n.locale === 'bn') {
            return product.text_bn
        } else {
            return product.text_en
        }
    },
    setPayment (item, ispartial) {
        this.is_payment = true
        this.payment.is_partial = ispartial
        this.search.edit_payment = true
        this.payment.amount = this.formData.amount
        this.payment.payment_id = this.formData.id
        this.payment.paymentList = this.formData
    }
  }
}
</script>
<style>
  .hidden_header {
    display: none
  }
  .card-border {
    border: 1px solid #b9bdc1;
    box-shadow: 1px 1px 6px -1px grey;
    background-color: #dee2e6;
  }
  [dir=ltr][mode=light] .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 10px;
  }
  .report-name{
    font-weight: bold !important;
    text-transform: uppercase;
  }
  .my-btn{
    padding: 2px !important;
  }
</style>
